import axios from 'axios'
import globalConfig from "../../../http/config";

axios.defaults.baseURL = process.env.BASE_API

const service = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8'
  },
  baseURL: globalConfig.baseUrl,
  // headers: globalConfig.headers,
  timeout: globalConfig.timeout,
  withCredentials: globalConfig.withCredentials
})
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
  }
)
export default service



// WEBPACK FOOTER //
// ./src/components/verifition/utils/axios.js